export interface DealViewSettings {
  viewingId: number;
  dealData: any;
  notes: string;
  quantity: number;
  redeemCode: string;
}
export default {
  quantity: 1,
} as DealViewSettings;

export const spaceName = 'caDeal';